const messages = {
  title: "Délai d'attente dépassé",
  description: "Nous sommes désolés pour le désagrément. Il semble que notre serveur n'ait pas reçu de réponse à temps.",
  backHomeButton: "Retour au tableau de bord",
}

export default {
  messages
}
